import { Slide } from './types'
import verkenUwWensenVoorZorgEnBehandeling from "./keuzehulpen/verken-uw-wensen-voor-zorg-en-behandeling";
import psa from './keuzehulpen/testen-prostaatkanker'
import trommelvliesBuisjes from './keuzehulpen/trommelvlies-buisjes'
import hevigMenstrueelBloedverlies from "./keuzehulpen/hevig-menstrueel-bloedverlies";
import verzakking from './keuzehulpen/verzakking'
import keelamandelen from './keuzehulpen/keelamandelen'
import dementie from './keuzehulpen/wel-of-geen-onderzoek-doen-naar-dementie'
import maagklachten from "./keuzehulpen/maagklachten";
import keelamandelenKinderen from "./keuzehulpen/keelamandelen-kinderen";
import pijnBijBevallen from "./keuzehulpen/pijn-bij-bevallen";
import erectieproblemen from "./keuzehulpen/erectieproblemen";
import opvliegers from "./keuzehulpen/opvliegers";
import cvrm from "./keuzehulpen/cvrm";
import hernia from "./keuzehulpen/hernia";
import depressie from "./keuzehulpen/depressie";
import hersenAneurysma from "./keuzehulpen/hersen-aneurysma";
import extremeVroeggeboorte from './keuzehulpen/extreme-vroeggeboorte';

export interface Keuzehulp {
  title: string
  basePath: string
  documentTitle: string
  routes: Slide[]
}

const keuzehulpen: Record<string, Keuzehulp> = {
    '/verken-uw-wensen-voor-zorg-en-behandeling': verkenUwWensenVoorZorgEnBehandeling,
    '/psa': psa,
    '/trommelvlies-buisjes': trommelvliesBuisjes,
    '/hevig-menstrueel-bloedverlies': hevigMenstrueelBloedverlies,
    '/verzakking': verzakking,
    '/keelamandelen': keelamandelen,
    '/wel-of-geen-onderzoek-doen-naar-dementie': dementie,
    '/maagklachten': maagklachten,
    '/keelamandelen-kinderen': keelamandelenKinderen,
    '/pijn-bij-bevallen': pijnBijBevallen,
    '/erectieproblemen': erectieproblemen,
    '/opvliegers': opvliegers,
    '/cvrm': cvrm,
    '/hernia': hernia,
    '/depressie': depressie,
    '/hersen-aneurysma': hersenAneurysma,
    '/extreme-vroeggeboorte': extremeVroeggeboorte
}

export default keuzehulpen
